export const getStoreCurrency = (): string => {
  return window.Shopify?.currency?.active || window.Shopify?.Checkout?.currency || 'AUD';
};
